module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', [_c('div', {
    staticClass: "node-info"
  }, [_c('a', {
    staticClass: "close-node-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeNodeInfo($event)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-cross"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-node"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.status != 'stopped',
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.startNode
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.status === 'stopped',
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.stopNode
    }
  }, [_vm._v("Stop")]), _vm._v(" "), (_vm.status === 'starting') ? _c('el-button', {
    attrs: {
      "type": "simple",
      "loading": true,
      "size": "small"
    }
  }, [_vm._v("Starting")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "node-addresses"
  }, [_c('br'), _vm._v(" "), (_vm.status === 'running') ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.node.addresses
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Node Info"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('strong', [_vm._v("ID:")]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.node.id))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Address:")]), _c('br'), _vm._v(_vm._s(scope.row))])]
      }
    }])
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('h4', [_vm._v("Connected peers " + _vm._s(_vm.node.peers.length) + " "), _c('div', [_vm._v(_vm._s(_vm.peersStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "node-peers"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.node.peers,
      "border": "",
      "empty-text": "No peers connected"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "peer-address",
    attrs: {
      "prop": "addr",
      "label": "Address"
    }
  })], 1)], 1)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "node-label"
  }, [_c('strong', [_vm._v("Ipfs Node")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bccc1ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NodeInfo.vue
// module id = 910
// module chunks = 1